import { AppState } from '@Redux/store';
import { Club, ClubStatus } from '@Models';

export const getClubsSelector = (state: AppState): Club[] =>
  state.clubs.entity
    ?.filter((club) => club.status === ClubStatus.active)
    ?.filter((club) => club.latitude !== null && club.longitude !== null) ?? [];
